var map = {
	"./decidim/avatar-multiuser.png": 98654,
	"./decidim/brands/facebook.svg": 13208,
	"./decidim/brands/google.svg": 93457,
	"./decidim/brands/twitter-x.svg": 10138,
	"./decidim/cc-badge.png": 52256,
	"./decidim/decidim-logo.svg": 2012,
	"./decidim/default-avatar.svg": 77220,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 7168,
	"./decidim/icons.svg": 31679,
	"./decidim/pattern.png": 58000,
	"./decidim/placeholder-card-g.svg": 55685,
	"./decidim/placeholder-card-l.svg": 22414,
	"./decidim/placeholder.jpg": 46077,
	"./decidim/remixicon.symbol.svg": 71985,
	"./decidim/vendor/social-share-button/douban.svg": 71536,
	"./decidim/vendor/social-share-button/email.svg": 29997,
	"./decidim/vendor/social-share-button/facebook.svg": 9651,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 35197,
	"./decidim/vendor/social-share-button/hacker_news.svg": 57357,
	"./decidim/vendor/social-share-button/linkedin.svg": 13189,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 22966,
	"./decidim/vendor/social-share-button/pinterest.svg": 96979,
	"./decidim/vendor/social-share-button/reddit.svg": 4583,
	"./decidim/vendor/social-share-button/telegram.svg": 19466,
	"./decidim/vendor/social-share-button/tumblr.svg": 35849,
	"./decidim/vendor/social-share-button/twitter.svg": 83036,
	"./decidim/vendor/social-share-button/vkontakte.svg": 19650,
	"./decidim/vendor/social-share-button/wechat.svg": 69613,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4253,
	"./decidim/vendor/social-share-button/x.svg": 55949,
	"./decidim/vendor/social-share-button/xing.svg": 72051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55367;